export enum PartnersFiltersFields {
  ACTIVE = 'active',
  HIDDEN = 'hidden',
  PHONE = 'phone',
  EMAIL = 'email',
  CREATED_AT = 'verified_at',
  LAST_LOGIN_AT = 'last_login_at',
  TITLE = 'title',
  STORE_TITLE = 'store_title',
}

export enum PartnerFormFieldsNames {
  TITLE = 'title',
  FIRST_NAME = 'first_name',
  MIDDLE_NAME = 'middle_name',
  LAST_NAME = 'last_name',
  EMAIL = 'email',
  PHONE = 'phone',
  TAX_CODE = 'organization_tax_code',
  ORGANIZATION_TAX_TYPE = 'organization_tax_type',
  IPN = 'ipn',
  ID = 'id',
  LEGAL_ADDRESS = 'legal_address',
  PHYSICAL_ADDRESS = 'physical_address',
  IBAN = 'iban',
  TAX_TYPE = 'tax_type',
  DOCUMENT = 'document',
  SUBSCRIBER_FULL_NAME = 'subscriber_full_name',
  BANK_NAME = 'bank_name',
  LEGAL_TYPE = 'legal_type',
  CATEGORY_MANAGER_ID = 'category_manager_id',
}

export enum TaxCodeTypes {
  EDRPOU = 'edrpou',
  IPN = 'ipn',
}

export enum PaymentTargetTypes {
  TOV = 'tov',
  FOP = 'fop',
}

export enum OwnershipTypes {
  LEGAL_ENTITY = 'legal_entity',
  FOP = 'fop',
}

export interface IPartnerCompanyDraft {
  ownership?: OwnershipTypes | null;
  vatPayer?: boolean | null;
  drfo?: string;
}

export interface IPartnerBankAccountsDraft {
  primaryMfo?: string;
}

export interface IPartnerAccountantDraft {
  noAccountant?: boolean | null;
  firstName?: string;
  lastName?: string;
  middleName?: string;
  email?: string;
  phone?: string;
}

export type TPartnerFormValues = {
  companyDraft?: IPartnerCompanyDraft;
  [PartnerFormFieldsNames.TITLE]: string;
  [PartnerFormFieldsNames.FIRST_NAME]: string;
  [PartnerFormFieldsNames.ID]: string;
  [PartnerFormFieldsNames.LAST_NAME]: string;
  [PartnerFormFieldsNames.MIDDLE_NAME]: string;
  [PartnerFormFieldsNames.EMAIL]: string;
  [PartnerFormFieldsNames.PHONE]: string;
  [PartnerFormFieldsNames.LEGAL_TYPE]: string;
  [PartnerFormFieldsNames.TAX_CODE]: string;
  [PartnerFormFieldsNames.IPN]?: string;
  [PartnerFormFieldsNames.ORGANIZATION_TAX_TYPE]: TaxCodeTypes;
  [PartnerFormFieldsNames.LEGAL_ADDRESS]: string;
  [PartnerFormFieldsNames.PHYSICAL_ADDRESS]: string;
  [PartnerFormFieldsNames.IBAN]: string;
  [PartnerFormFieldsNames.TAX_TYPE]: string;
  [PartnerFormFieldsNames.DOCUMENT]: string;
  [PartnerFormFieldsNames.SUBSCRIBER_FULL_NAME]: string;
  [PartnerFormFieldsNames.BANK_NAME]: string;
  [PartnerFormFieldsNames.CATEGORY_MANAGER_ID]?: string;
  bankAccountsDraft?: IPartnerBankAccountsDraft;
  accountantDraft?: IPartnerAccountantDraft;
};

export type TGetPartnerQuery = {
  [PartnersFiltersFields.ACTIVE]?: '0' | '1';
  [PartnersFiltersFields.HIDDEN]?: '0' | '1';
  [PartnersFiltersFields.PHONE]?: string;
  [PartnersFiltersFields.EMAIL]?: string;
  [PartnersFiltersFields.CREATED_AT]?: string;
  [PartnersFiltersFields.LAST_LOGIN_AT]?: string;
  [PartnersFiltersFields.TITLE]?: string;
  [PartnersFiltersFields.STORE_TITLE]?: string;
};
